export default __webpack_public_path__ + "static/media/tex11.e693a6ec.jpg";